/* eslint class-methods-use-this: 0 */

class Hotspot {
    constructor(values) {
        if (values) {
            Object.keys(values).forEach(k => {
                if (this.constructor.prototype.hasOwnProperty(k)) {
                    this[k] = values[k];
                }
            });
        }
    }

    get type() {
        return 'Hotspot';
    }

    set id(id) {
        this._id = id;
    }

    get id() {
        return this._id;
    }

    get topLeftPoint() {
        return this._topLeftPoint;
    }

    set topLeftPoint(topLeftPoint) {
        this._topLeftPoint = topLeftPoint;
    }

    get bottomRightPoint() {
        return this._bottomRightPoint;
    }

    set bottomRightPoint(bottomRightPoint) {
        this._bottomRightPoint = bottomRightPoint;
    }

    get strokeColor() {
        return this._strokeColor;
    }

    set strokeColor(strokeColor) {
        this._strokeColor = strokeColor;
    }

    get strokeWeight() {
        return this._strokeWeight;
    }

    set strokeWeight(strokeWeight) {
        this._strokeWeight = strokeWeight;
    }

    get opacity() {
        return this._opacity;
    }

    set opacity(opacity) {
        this._opacity = opacity;
    }

    get title() {
        return this._title;
    }

    set title(title) {
        this._title = title;
    }

    get createdAtZoomLevel() {
        return this._createdAtZoomLevel;
    }

    set createdAtZoomLevel(createdAtZoomLevel) {
        this._createdAtZoomLevel = createdAtZoomLevel;
    }

    get minZoom() {
        return this._minZoom;
    }

    set minZoom(minZoom) {
        this._minZoom = minZoom;
    }

    get maxZoom() {
        return this._maxZoom;
    }

    set maxZoom(maxZoom) {
        this._maxZoom = maxZoom;
    }

    get description() {
        return this._description;
    }

    set description(description) {
        this._description = description;
    }

    get legendOrder() {
        return this._legendOrder;
    }

    set legendOrder(legendOrder) {
        this._legendOrder = legendOrder;
    }

    get includedInLegend() {
        return this._includedInLegend;
    }

    set includedInLegend(includedInLegend) {
        this._includedInLegend = includedInLegend;
    }

    equals(that) {
        return (this.id === that.id &&
        this.type === that.type &&
        this.opacity === that.opacity &&
        this.title === that.title &&
        this.strokeColor === that.strokeColor &&
        this.strokeWeight === that.strokeWeight &&
        this.createdAtZoomLevel === that.createdAtZoomLevel &&
        this.minZoom === that.minZoom &&
        this.maxZoom === that.maxZoom &&
        this.includedInLegend === that.includedInLegend &&
        this.description === that.description &&
        this.legendOrder === that.legendOrder &&
        this.topLeftPoint === that.topLeftPoint &&
        this.bottomRightPoint === that.bottomRightPoint);
    }

    clone() {
        return new Hotspot({
            id: `${this.id}`,
            opacity: this.opacity,
            title: this.title,
            strokeColor: this.strokeColor,
            strokeWeight: this.strokeWeight,
            createdAtZoomLevel: this.createdAtZoomLevel,
            minZoom: this.minZoom,
            maxZoom: this.maxZoom,
            includedInLegend: this.includedInLegend,
            description: this.description,
            topLeftPoint: this.topLeftPoint,
            bottomRightPoint: this.bottomRightPoint,
            legendOrder: this.legendOrder,
        });
    }

    toJSON() {
        return {
            id: `${this.id}`,
            type: this.type,
            opacity: this.opacity,
            title: this.title,
            strokeColor: this.strokeColor,
            strokeWeight: this.strokeWeight,
            createdAtZoomLevel: this.createdAtZoomLevel,
            minZoom: this.minZoom,
            maxZoom: this.maxZoom,
            includedInLegend: this.includedInLegend,
            description: this.description,
            topLeftPoint: this.topLeftPoint,
            bottomRightPoint: this.bottomRightPoint,
            legendOrder: this.legendOrder,
        };
    }
}

export default Hotspot;
